import React, { useEffect, useState } from "react";
import {
  // Button,
  Avatar,
  message,
} from "antd";
import {
  Box,
  Typography,
  Paper,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import styles from "./UserList.module.css";
import SearchInput from "../../../../components/common/SearchInput";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import Breadcrumb from "../../../../components/common/Breadcrumb";
import ApiCallService from "../../../../Service/ApiCallService";
import { UserOutlined } from "@ant-design/icons";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import ReactTable from "../../../../components/common/ReactTable";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageLimit, setCurrentPageLimit] = useState(10); // Default limit
  const [searchTerm, setSearchTerm] = useState("");
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [newRole, setNewRole] = useState("");
  const [userName, setUserName] = useState("");
  const [isActive, setIsActive] = useState("active");
  const [sortBy, setSortBy] = useState("userFirstName");
  const [sortOrder, setSortOrder] = useState("asc");

  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/users?search=${searchTerm}&sortBy=${sortBy}&sortOrder=${sortOrder}&status=${isActive}`
      );
      const verifiedUsers = response.data.filter(
        (user) => user.verified === "verified"
      );
      setUsers(verifiedUsers);
      setTotalPages(response.meta.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [currentPage, searchTerm, currentPageLimit, isActive, sortBy, sortOrder]);

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatAddress = (user) => {
    return `${user.State?.stateName || ""}, ${user.Region?.regionName || ""}, ${
      user.District?.districtName || ""
    }, ${user.Taluka?.talukaName || ""}, ${user.Village?.villageName || ""}, ${
      user.pinCode || ""
    }`;
  }; // need to decide whether to show pincode   or not when showing regions

  const formatFullName = (user) => {
    const { userFirstName, userMiddleName, userLastName } = user;
    return userMiddleName
      ? `${userFirstName} ${userMiddleName} ${userLastName}`
      : `${userFirstName} ${userLastName}`;
  };

  const showConfirmModal = (record, role) => {
    setUserName(`${record.userFirstName} ${record.userLastName}`);
    setCurrentUserId(record._id);
    setConfirmModalVisible(true);
    setNewRole(role);
  };

  const handleRoleChange = async () => {
    if (currentUserId) {
      try {
        setLoading(true);
        await ApiCallService.patch(
          `${process.env.REACT_APP_BASE_URL}/user/updateuserrole/${currentUserId}`,
          { role: newRole }
        );

        setNewRole(
          users.map((user) =>
            user._id === currentUserId ? { ...user, userRole: newRole } : user
          )
        );
        message.success("User role updated successfully");
        await fetchUsers();
      } catch (error) {
        console.error("Error updating user role:", error);
        message.error(`Error: ${error.message || "Something went wrong"}`);
      } finally {
        setLoading(false);
        setConfirmModalVisible(false);
      }
    }
  };

  const handleCancel = () => {
    setConfirmModalVisible(false); // Close the modal
  };

  const columns = [
    
    {
      field: "fullName",
      headerName: "Name",
      renderCell: (row) => (
        formatFullName(row)
      ),
      searchKey: (row) => formatFullName(row),
    },
    {
      field: "contact",
      headerName: "Contact",
      disableSort: true,
      renderCell: (row) => (
        <>
          <div>{row.mobileNumber}</div>
          {row.alternateNumber && <div>{row.alternateNumber}</div>}
        </>
      ),
      searchKey: (row) =>
    `${row.mobileNumber || ""} ${row.alternateNumber || ""}`,
    },
    // {
    //   field: "emailId",
    //   headerName: "Email",
    //   disableSort: true,
    // },
    // {
    //   field: "dob",
    //   headerName: "Date of Birth",
    //   renderCell: (row) => formatDate(row.dob),
    //   disableSort: true,
    //   disableSearch: true,
    // },
    // {
    //   field: "address",
    //   headerName: "Address",
    //   renderCell: (row) => formatAddress(row),
    //   disableSort: true,
    //   // disableSearch: true,
    //   searchKey: (row) => formatAddress(row),
    // },
    // {
    //   field: "userRole",
    //   headerName: "Role",
    //   disableSort: true,
    //   // disableSearch: true,
    //   renderCell: (row) => (
    //     <Select
    //       style={{ width: 130 }}
    //       value={row.userRole}
    //       disabled={
    //         !(isSuperUser || isAdmin) ||
    //         row.userStatus === "inactive" ||
    //         (isSuperUser && row.userRole === "SuperUser") ||
    //         (isAdmin &&
    //           (row.userRole === "SuperUser" || row.userRole === "Admin"))
    //       }
    //       onChange={(value) => showConfirmModal(row, value)}
    //     >
    //       <Select.Option value="Admin">Admin</Select.Option>
    //       <Select.Option value="User">User</Select.Option>
    //       {/* <Select.Option value="SuperUser">Superuser</Select.Option> */}
    //     </Select>
    //   ),
    // },


 {
  field: "lastLogin",
  headerName: "Last Login",
  renderCell: (row) => {
    if (!row.lastLogin) return "Not found";

    return new Date(row.lastLogin).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  },
  disableSort: true,
  disableSearch: true,
  searchKey: (row) => row.lastLogin || "",
},


    {
      field: "actions",
      headerName: "Actions",
      disableSort: true,
      disableSearch: true,
      renderCell: (row) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1, // equivalent to 8px
            alignContent:"center"
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{width:{xs: "100%", sm:"50%", md:"40%"}}}
            onClick={() =>
              navigate(`/profile/${row._id}`, {
                state: { mode: "view", navigateFrom: "usersList" },
              })
            }
          >
            View
          </Button>
        </Box>
      ),
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSearchChange = (value) => {
    if (value.length >= 3) {
      setSearchTerm(value);
    } else if (value.length == 0) {
      setSearchTerm("");
    }
    setCurrentPage(1);
  };

  // const breadcrumbItems = [
  //   { label: "Nexus", path: "/" },
  //   { label: "VM", path: "/vm/dashboard" },
  //   { label: "Users List" },
  // ];

  return (
    <>
      <Paper
        elevation={0}
        variant="pageBg"
        // sx={{
        //   p: 1,
        //   mb: 3,
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "space-between",
        //   backgroundColor: "#fafafa",
        //   borderRadius: 2,
        // }}
      >
        <span style={{display:"flex", flexDirection:"row", textAlign:"center"}}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              flexGrow: 1,
            }}
          >
            User List
          </Typography>
          <Box sx={{ textAlign: "center" }}>
            <Switch
              checked={isActive === "active"}
              onChange={(e) => {
                setIsActive(e.target.checked ? "active" : "inactive");
                setCurrentPage(1);
              }}
              color="success"
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: isActive === "active" ? "green" : "red",
                mt: 0.5,
              }}
            >
              {isActive === "active" ? "Active" : "Inactive"}
            </Typography>
          </Box>
        </span>
      <Box
        sx={{
          width: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <ReactTable
            columns={columns}
            initialRowsPerPage={10}
            rows={users}
            rowKey="_id"
            loading={loading}
            style={{ height: "100%", width: "100%" }}
          />
        </Box>
      </Box>

      <Dialog open={confirmModalVisible} onClose={handleCancel}>
        <DialogTitle>Confirm Role Change</DialogTitle>
        <DialogContent>
          Are you sure you want to change {userName}'s role to {newRole}?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            onClick={handleRoleChange}
            variant="contained"
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      </Paper>
    </>
  );
};

export default UserList;
